// @ts-nocheck
import _ from 'lodash';
import React, { createContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, useMediaQuery } from '@material-ui/core';
import lightTheme from '../themes/lightTheme';
import darkTheme from '../themes/darkTheme';

export const AppThemeContext = createContext();

export const Theme = {
  light: lightTheme,
  dark: darkTheme,
};

function AppThemeProvider(props) {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [theme, _setTheme] = useState(
    _.defaultTo(localStorage.getItem('appTheme'), prefersDarkMode ? 'dark' : 'light')
  );

  const setTheme = useCallback(name => {
    if (!Theme[name]) {
      return;
    }
    localStorage.setItem('appTheme', name);
    _setTheme(name);
  }, []);

  const { children } = props;

  return (
    <AppThemeContext.Provider value={{ theme, setTheme }}>
      <ThemeProvider theme={{ ...Theme[theme] }}>{children}</ThemeProvider>
    </AppThemeContext.Provider>
  );
}

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppThemeProvider;
